/** @format */

import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '../loader';

const AudioPlayback = lazy(
  () => import(/* webpackChunkName: "audio-playback" */ './audio-playback')
);

/**
 * Audio Playback
 */
export const audioPlayback = (): void => {
  const audioPlaybackContainer: NodeListOf<HTMLElement> | null =
    document.querySelectorAll('.audio-playback-component');

  if (audioPlaybackContainer) {
    audioPlaybackContainer.forEach((audioPlayback, index) => {
      const { dataset } = audioPlayback;
      const innerHTML = audioPlayback.innerHTML;
      const root = createRoot(audioPlaybackContainer[index]);
      root.render(
        <Suspense fallback={<Loader />}>
          <AudioPlayback podcastData={dataset} innerHTML={innerHTML} />
        </Suspense>
      );
    });
  }
};
